// DO NOT EDIT -- generated from Go package fs/shared/schema

import * as segment from './fs_api_segment';


///////////
// Enums //
///////////

// PageTypeEnum defines the values of the PageType field in PageDesc responses
export enum PageTypeEnum {
	PageTypeWeb = "web",
	PageTypeAndroid = "android",
	PageTypeiOS = "ios",
	PageTypeMobileMock = "mobilemock",
	PageTypeServer = "server"
}

// PlatformEnum defines the searchable values of the PagePlatform field
export enum PlatformEnum {
	PlatformWeb = "Web",
	PlatformNativeMobile = "Native Mobile",
	PlatformServer = "Server"
}

// DeviceEnum defines the searchable values of the PageDevice field
export enum DeviceEnum {
	DeviceDesktop = "Desktop",
	DeviceMobile = "Mobile",
	DeviceTablet = "Tablet",
	DeviceRobot = "Robot",
	DeviceUnknown = "Unknown"
}

// OSEnum defines the searchable values of the PageOperatingSystem field
export enum OSEnum {
	OSWindows = "Windows",
	OSOSX = "OS X",
	OSChromeOS = "Chrome OS",
	OSAndroid = "Android",
	OSiOS = "iOS",
	OSLinux = "Linux",
	OSWindowsPhone = "Windows Phone",
	OSRobot = "Robot",
	OSUnknown = "Unknown"
}

// BrowserEnum defines the searchable values of the PageBrowser field
export enum BrowserEnum {
	BrowserChrome = "Chrome",
	BrowserCocCoc = "Coc Coc",
	BrowserCustomAgent = "Custom Agent",
	BrowserCustomMobileAgent = "Custom Mobile Agent",
	BrowserDuckDuckGo = "DuckDuckGo",
	BrowserInternetExplorer = "Internet Explorer",
	BrowserElectron = "Electron",
	BrowserFirefox = "Firefox",
	BrowserLynx = "Lynx",
	BrowserMicrosoftEdge = "Microsoft Edge",
	BrowserMobileApp = "Mobile App",
	BrowserMozillaOther = "Mozilla (Other)",
	BrowserOpera = "Opera",
	BrowserSafari = "Safari",
	BrowserSeaMonkey = "SeaMonkey",
	BrowserRobot = "Robot",
	BrowserUCWeb = "UC Browser",
	BrowserUnknown = "Unknown",
	BrowserYandex = "Yandex"
}

export enum ErrorClickCode {
	ERROR_CLICK_CODE_INVALID = 0,
	ERROR_CLICK_CODE_UNKNOWN = 1,
	ERROR_CLICK_CODE_CONSOLE = 2,
	ERROR_CLICK_CODE_EXCEPTION = 3
}

export enum SearchFieldType {
	SEARCH_TYPE_STRING = "str",
	SEARCH_TYPE_TEXT = "text",
	SEARCH_TYPE_EMAIL = "email",
	SEARCH_TYPE_BOOL = "bool",
	SEARCH_TYPE_INT = "int",
	SEARCH_TYPE_REAL = "real",
	SEARCH_TYPE_DATE = "date",
	SEARCH_TYPE_URL = "url",
	SEARCH_TYPE_DURATION = "duration",
	SEARCH_TYPE_SELECTOR = "selector",
	SEARCH_TYPE_NUMSTRING = "numstr"
}

export enum DetectedMobileFramework {
	REACT_NATIVE = "REACT_NATIVE",
	FLUTTER = "FLUTTER",
	CORDOVA = "CORDOVA",
	IONIC = "IONIC",
	SWIFTUI = "SWIFTUI",
	JETPACK_COMPOSE = "JETPACK_COMPOSE",
	CAPACITOR = "CAPACITOR",
	FABRIC = "FABRIC"
}

// OpportunitySignalType describes the particular type of input for the impact
export enum OpportunitySignalType {
	SIGNAL_TYPE_INVALID = 0,
	SIGNAL_TYPE_BAD_CLICK = 1,
	SIGNAL_TYPE_PERF_EVENT = 2,
	SIGNAL_TYPE_CUSTOM_EVENT = 3,
	SIGNAL_TYPE_SEEN_EVENT = 4,
	SIGNAL_TYPE_CUSTOM = 5,
	SIGNAL_TYPE_DEFINED_EVENT = 6,
	SIGNAL_TYPE_AJAX_ERROR = 7,
	SIGNAL_TYPE_WEB_VITAL = 8,
	SIGNAL_TYPE_PAGE_VIEW = 9
}

// OpportunityBadClickType further describes OpportunitySignalType_SIGNAL_TYPE_BAD_CLICK
export enum OpportunityBadClickType {
	CLICK_TYPE_INVALID = 0,
	CLICK_TYPE_RAGE = 1,
	CLICK_TYPE_ERROR = 2,
	CLICK_TYPE_DEAD = 3
}

export enum OpportunityWebVitalType {
	WEB_VITAL_TYPE_INVALID = 0,
	WEB_VITAL_TYPE_FID = 1,
	WEB_VITAL_TYPE_CLS = 2,
	WEB_VITAL_TYPE_LCP = 3,
	WEB_VITAL_TYPE_INP = 4,
	WEB_VITAL_TYPE_TTI = 5,
	WEB_VITAL_TYPE_TBT = 6,
	WEB_VITAL_TYPE_TTFB = 7
}

export enum SearchOperator {
	SEARCH_OP_IS = "is",
	SEARCH_OP_NIS_dontuse = "nis",
	SEARCH_OP_UNTOK_SW_dontuse = "usw",
	SEARCH_OP_CONTAINS_TOKEN = ":",
	SEARCH_OP_CONTAINS_TOKEN_SW = "^:",
	SEARCH_OP_DOES_NOT_CONTAIN_TOKEN = "-:",
	SEARCH_OP_EQ = "==",
	SEARCH_OP_NEQ = "!=",
	SEARCH_OP_LT = "<",
	SEARCH_OP_LTE = "<=",
	SEARCH_OP_GT = ">",
	SEARCH_OP_GTE = ">=",
	SEARCH_OP_OLD_SW = "><",
	SEARCH_OP_SW = "^=",
	SEARCH_OP_EW = "$=",
	SEARCH_OP_SUBSTR = "^$",
	SEARCH_OP_NOT_SW = "!^=",
	SEARCH_OP_NOT_EW = "!$=",
	SEARCH_OP_NOT_SUBSTR = "!^$",
	SEARCH_OP_RNGCC = "[]",
	SEARCH_OP_RNGOO = "{}",
	SEARCH_OP_RNGOC = "{]",
	SEARCH_OP_RNGCO = "[}",
	SEARCH_OP_NOT_RNGCC = "-[]",
	SEARCH_OP_NOT_RNGOO = "-{}",
	SEARCH_OP_NOT_RNGOC = "-{]",
	SEARCH_OP_NOT_RNGCO = "-[}"
}


///////////////
// Constants //
///////////////

export const CannedSegmentCreator: string = "system";
export const EveryoneSegmentId: string = "everyone";
export const SignedupSegmentId: string = "signedUpUsers";
export const NewThisWeekSegmentId: string = "newThisWeek";
export const RageSegmentId: string = "rageClicks";
export const MobileSegmentId: string = "mobileUsers";

/////////////
// Structs //
/////////////

export interface TimeRange {
  Start: string;
  End: string;
}

export interface DocumentCriterion {
  Field: string;
  Op: SearchOperator;
  Value: unknown;
}

// TODO(jaime, scottb): Replace with new composable Audience Grammar (once designed)!
export interface SearchCriteria {
  Version?: number;
  InSameSession?: boolean;
  EnforceEventOrder?: boolean;
  Platform?: PlatformEnum;
  TimeRange?: TimeRange | null;
  UserTipCriteria?: Array<DocumentCriterion | null> | null;
  EventCriteria?: Array<Array<DocumentCriterion | null> | null> | null;
  EventNeverCriteria?: Array<Array<DocumentCriterion | null> | null> | null;
}

export interface SearchField {
  Name: string;
  Type: SearchFieldType;
}

// Enough data to identify a particular event for navigating playback to an exact point.
export interface EventMarker {
  IndvId: string;
  UserId: string;
  SessionId: string;
  PageId: string;
  PageStart: number;
  EventPageOffsetMs: number;
  EventSessionOffsetMs: number;
}

// A set of events denoting a clip. The events should always be sorted by their event start time.
export interface Clip {
  Markers: Array<EventMarker | null> | null;
  LastMatchingCity: string;
  LastMatchingPage: string;
  LastMatchingBrowser: string;
  LastMatchingDevice: string;
  LastMatchingOperatingSystem: string;
  LastMatchingPlatform: PlatformEnum;
  LastMatchingOperatingSystemVersion: string;
  LastMatchingAppVersion: string;
  LastMatchingDeviceModel: string;
  LastMatchingAppName: string;
  LastMatchingEventName: string;
  LastMatchingEventVars: string;
  LastMatchingCaptureSourceIntegration: string;
}

// A single search result from calling SearchSessions.
export interface SearchSession {
  IndvId: string;
  UserSessionId: string;
  LastEventTime: number;
  DurationInSeconds: number;
  NumPages: number;
  NumEvents: number;
  LastMatchingCity: string;
  LastMatchingPage: string;
  LastMatchingBrowser: string;
  LastMatchingDevice: string;
  LastMatchingOperatingSystem: string;
  LastMatchingPlatform: PlatformEnum;
  LastMatchingOperatingSystemVersion: string;
  LastMatchingAppVersion: string;
  LastMatchingDeviceModel: string;
  LastMatchingAppName: string;
  LastMatchingEventName: string;
  LastMatchingEventVars: string;
  LastMatchingCaptureSourceIntegration: string;
}

// A list of search results from calling SearchSessions.
// Warning: It is possible that Clips contains references to session ids that are not present in Sessions, because
// Sessions is built from session tips, which are refreshed only periodically. Thus, a clip can be found whose session
// does not yet have a session tip record.
export interface SearchSessionsResponse {
  Clips: Array<Clip | null> | null;
  Sessions: Array<SearchSession | null> | null;
}

// AppData packages application metadata for a native mobile session.
export interface AppData {
  Version?: string;
  PackageName?: string;
  Name?: string;
  BuildType?: string;
  FsVersion?: string;
  FsBuildId?: string;
  StableSelectors: boolean;
  DetectedMobileFrameworks?: DetectedMobileFramework[] | null;
}

// DeviceData packages device hardware and OS information for a native mobile session.
export interface DeviceData {
  OsVersion: string;
  OsProduct: string;
  Model: string;
  Manufacturer: string;
  Display: string;
  Serial: string;
  Features: string[] | null;
}

// OpportunityPerfEventMetadata is the metadata for OpportunitySignalType_SIGNAL_TYPE_PERF_EVENT
export interface OpportunityPerfEventMetadata {
  RangeStart: string;
  RangeEnd: string;
  PageField: string;
  FieldOperator: string;
  PagePerformanceField: string;
}

// OpportunityApiEventProperty are properties for OpportunityCustomEvent
export interface OpportunityApiEventProperty {
  PropertyName: string;
  PropertyValues: string[] | null;
}

// OpportunityCustomEvent further describes OpportunitySignalType_SIGNAL_TYPE_CUSTOM
export interface OpportunityCustomEvent {
  Name: string;
  Slug: string;
  Properties: Array<OpportunityApiEventProperty | null> | null;
}

// OpportunityPageViewEvent further describes OpportunitySignalType_SIGNAL_TYPE_PAGE_VIEW using a string for PageViewId to represent the full Int64 in javascript
export interface OpportunityPageViewEvent {
  PageViewId: string;
  Slug: string;
  Properties: Array<OpportunityApiEventProperty | null> | null;
}

// OpportunityWebVitalMetadata is the metadata for OpportunitySignalType_SIGNAL_TYPE_PERF_EVENT
export interface OpportunityWebVitalMetadata {
  RangeStart: string;
  RangeEnd: string;
  CoreWebVital: OpportunityWebVitalType;
  IsMobile: boolean;
}

// OpportunitySignal is the input for the impact
export interface OpportunitySignal {
  Type: OpportunitySignalType;
  Event?: segment.EventJSON | null;
  ClickType?: OpportunityBadClickType | null;
  PerformanceMetadata?: OpportunityPerfEventMetadata | null;
  CustomEvent?: OpportunityCustomEvent | null;
  SeenEventName?: string | null;
  DefinedEventID?: string | null;
  CoreWebVital?: OpportunityWebVitalMetadata | null;
  PageViewEvent?: OpportunityPageViewEvent | null;
}
